import { GetLoyaltyCollectionByIdResponseDto } from '@src/api';

import { LoyaltyProgramCollection } from '../types';

import { productApiToProductUI } from './productApiToProductUI';

export const collectionApiToCollectionUI = (
  apiCollection: GetLoyaltyCollectionByIdResponseDto,
): LoyaltyProgramCollection => {
  return {
    ...apiCollection,
    bannerTitle: apiCollection.bannerTitle ?? '',
    sections:
      apiCollection.sections?.map(section => {
        return {
          contentText: section.contentText,
          products:
            section.products?.map(product => {
              return productApiToProductUI(product);
            }) ?? [],
        };
      }) ?? [],
  };
};
